'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tile = require('./Tile');

var _Tile2 = _interopRequireDefault(_Tile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Tile2["default"];
module.exports = exports['default'];